import React from "react";
import "./mapedokumentacija.css";
import MapeDokumentacijaItem from "../mapeDokumentacijaItem";

export default function MapeDokumentacija({
  list,
  designations,
  handleChangeResponsibleDesignations,
  handleChangeDynamicDescription,
  handleSelectDueDate,
  handleChangeDocumentPath,
  handleSetEditProcedureRow,
  handleUpdateProcedureRow,
  handleChangeProcedureRow,
  handleSelectProceduraRowResponsibles,
  handleRejectMapaDukument,
  handleChangeProcedureRowDueDate,
  handleChangeNewMapaDocument,
  handleAddNewMapaDocumentList,
  handleAddMapaDocumentName,
  handleRemoveMapaDocument,
  handleUploadMapaDocument,
  setActivityToDelete,
  mapa,
  validationsErrors,
  canEdit = true,
  children,
}) {
  const mapedokumentacijaTitles = [
    { id: 0, title: "KORAK", width: "5%" },
    { id: 1, title: "DIJAGRAM TOKA", width: "18%" },
    { id: 2, title: "OPIS AKTIVNOSTI", width: "28%" },
    { id: 3, title: "IZVRŠENJE", width: "30%" },
    { id: 4, title: "PROPRATNI DOKUMENTI", width: "19%" },
  ];

  const formatDesignations = (list) => {
    if (list) {
      if (list.some((el) => el.value)) {
        return list;
      } else {
        return list.map((item) => {
          const worker = (designations || []).find((des) => {
            return des.id === item.designation_id;
          });
          if (worker) return { value: worker, label: worker.name };

          // QA-A-03: radno mesto je obrisano (nije među živim radnim mestima),
          // a korak ga i dalje referencira — prikazuje se naziv iz reference
          // (backend ga šalje kao item.name) uz oznaku, bez pada strane.
          // Referenca se čuva: pri čuvanju koraka ide isti designation_id.
          const name = `${item.name || "Radno mesto"} (obrisano)`;
          return {
            value: { id: item.designation_id, name },
            label: name,
          };
        });
      }
    }
  };

  return (
    <div className="table mapedokumentacija-table">
      <ul className="table-header">
        {mapedokumentacijaTitles.map((title, index) => {
          if (title.id === 3) {
            return (
              <li
                key={title.id}
                className="table-header-item mapedokumentacija-exec-header"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  color: "var(--mainColor)",
                }}
              >
                <div
                  className="mapedokumentacija-exec-title"
                  style={{
                    width: "100%",
                    fontWeight: "900",
                    textAlign: "center",
                    borderBottom: "1px solid var(--mainColor)",
                    height: "50%",
                    paddingTop: "0",
                  }}
                >
                  IZVRŠENJE
                </div>
                <div
                  className="mapedokumentacija-exec-subheader"
                  style={{ display: "flex", flex: "1" }}
                >
                  <div
                    className="mapedokumentacija-exec-subheader-left"
                    style={{
                      borderRight: "1px solid var(--mainColor)",
                      width: "55%",
                      justifyContent: "center",
                      display: "flex",
                      alignItems: "center",
                      padding: "0",
                    }}
                  >
                    ODGOVORNOST
                  </div>
                  <div
                    className="mapedokumentacija-exec-subheader-right"
                    style={{
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "45%",
                    }}
                  >
                    ROK
                  </div>
                </div>
              </li>
            );
          }
          return (
            <li
              className="table-header-item"
              key={title.id}
            >
              <p className="table-header-title">{title.title}</p>
            </li>
          );
        })}
      </ul>
      <div className="poslovli-proseci-table-list">
        {list &&
          list.length > 0 &&
          list.map((item, index) => {
            return (
              <MapeDokumentacijaItem
                key={index}
                name={item.name}
                description={item.description}
                designations={designations}
                handleChangeResponsibleDesignations={handleChangeResponsibleDesignations(
                  index
                )}
                selectedResponsibilityDesignations={
                  item.selectedResponsibilityDesignations
                }
                handleSelectDueDate={handleSelectDueDate}
                dueDate={item.due_date}
                handleChangeDynamicDescription={handleChangeDynamicDescription(
                  index
                )}
                handleChangeDocumentPath={handleChangeDocumentPath(index)}
                link={item.link}
                responsibles={formatDesignations(item?.activities_designations)}
                index={index}
                editing={item?.editing}
                links={item.activities_documents}
                handleSetEditProcedureRow={handleSetEditProcedureRow}
                row={item}
                handleUpdateProcedureRow={handleUpdateProcedureRow}
                handleChangeProcedureRow={handleChangeProcedureRow}
                handleSelectProceduraRowResponsibles={
                  handleSelectProceduraRowResponsibles
                }
                handleChangeProcedureRowDueDate={
                  handleChangeProcedureRowDueDate
                }
                handleChangeNewMapaDocument={handleChangeNewMapaDocument}
                handleAddNewMapaDocumentList={handleAddNewMapaDocumentList}
                handleRejectMapaDukument={handleRejectMapaDukument}
                handleAddMapaDocumentName={handleAddMapaDocumentName}
                handleRemoveMapaDocument={handleRemoveMapaDocument}
                handleUploadMapaDocument={handleUploadMapaDocument}
                setActivityToDelete={setActivityToDelete}
                mapa={mapa}
                list={list}
                validationsErrors={validationsErrors}
                canEdit={canEdit}
                stepNumber={index + 1}
                isLastStep={index === list.length - 1}
              />
            );
          })}
        {children}
      </div>
    </div>
  );
}
